import React from "react";
import BCA_MCA from "../Components/BCA_MCA";
import GalleryCarousel from "../Components/GalleryCarousel";
// import AdmissonProcessAccordion from "../Components/AdmissonProcessAccordion";
import { Helmet } from "react-helmet";
import { BsLightningFill } from "react-icons/bs";

function AdmissionProcess() {
  return (
		<>
			<Helmet>
				<title>Admission Process | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="AdmissionHeader HeaderImg">
					<img
						src="/Images/Banner/AdmissionProcess.png"
						alt="admission-banner"
					/>
				</div>

				<div id="Heading" data-aos="fade-up">
					<h1>Admission Process</h1>
				</div>

        {/* Integrated B.A.-B.Ed. Process */}
        <div className="Section" style={{ marginBottom: "40px" }} data-aos="fade-up">
          <div id="Secondary_Heading">
            <h3>Integrated B.A.-B.Ed.</h3>
          </div>
          <p style={{marginBottom: "15px"}}>
            Application form can be obtained from the University Department of
            Education, Kautilya Bhavan, Vinoba Bhave University Campus, Hazaribag.
            It is to be duly filled in by the candidate and submitted to the above
            office along with all relevant documents such as:
          </p>
          <ul style={{marginBottom: "20px"}}>
						{[
              "Attested Photocopy of the Matriculation/ICSE/CBSE pass certificate (Date of Birth proof).",
              "Attested Photocopy of mark sheet of I.A./I.Sc./I.Com. examination.",
              "Recent Colour stamp/passport size photograph.",
              "Attested Photocopy of caste certificate issued by the authority not below the rank of SDO.",
              "NCC Certificate (if applicable).",
              "One self-addressed envelope with stamp of forty two (42) rupees."
            ].map((item, index) => (
              <li key={index} style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
								<div style={{ minWidth: "15px", marginTop: "5px" }}>
									<BsLightningFill className="check-icon" />
								</div>
								<div style={{ flex: 1 }}>{item}</div>
							</li>
            ))}
          </ul>
          
          <div className="SubHeading">
            <h4 style={{ color: "#d32f2f" }}>Selection Procedure</h4>
          </div>
          <p>
            The selection of candidates for admission to 4 years integrated
            B.A./ B.Sc.- B.Ed. course will be done strictly in accordance with
            the merit list prepared on the basis of rules and regulations laid
            down by the Govt. of Jharkhand and Vinoba Bhave University,
            Hazaribag.
          </p>
        </div>

        {/* M.Ed. Process */}
        <div className="Section" style={{ marginBottom: "40px" }} data-aos="fade-up">
          <div id="Secondary_Heading">
            <h3>M.Ed.</h3>
          </div>
          <p style={{marginBottom: "15px"}}>
             Application form can be obtained from the office of the University Department of Education, Vinoba Bhave University Campus, Hazaribag. 
             It is to be duly filled in by the candidate and submitted to the above office along with all relevant documents.
          </p>
           <ul style={{marginBottom: "20px"}}>
						{[
              "Attested Photocopy of the Matriculation / ICSE / CBSE pass certificate, showing the candidate's date of birth.",
              "Attested Photocopy of mark sheet of I.A./I.Sc./I.Com. examination.",
              "Attested Photocopy of marks sheet of Bachelor Degree, Master Degree and B.Ed.",
              "Recent Colour stamp size photograph.",
              "Attested Photocopy of caste certificate issued by the authority not below the rank of SDO."
            ].map((item, index) => (
               <li key={index} style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
								<div style={{ minWidth: "15px", marginTop: "5px" }}>
									<BsLightningFill className="check-icon" />
								</div>
								<div style={{ flex: 1 }}>{item}</div>
							</li>
            ))}
          </ul>

          <div className="SubHeading">
            <h4 style={{ color: "#d32f2f" }}>Selection Procedure</h4>
          </div>
          <p>
            Admission in above course shall be on the basis of your obtained career points which is fixed by the university authority.
            The selection of candidates will be done strictly in accordance with the merit list prepared on the basis of rules and regulations.
          </p>
        </div>

				<div className="Admission_process_Courses">
					<div id="Secondary_Heading" data-aos="fade-up">
						<h3>Courses</h3>
					</div>
					<BCA_MCA />
					<GalleryCarousel />
				</div>
			</div>
		</>
	);
}

export default AdmissionProcess;
